import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { connect } from "react-redux";

import {
  emptyString,
  eventDateConstant,
  marketingAttributionReduxConstants,
} from "../../../../views/shared-screens/constants";
import { marketingAttributionActions } from "../../../../views/shared-screens/redux/actions";
import { useSpinner } from "../../hooks";

const MarketingAttributionReportBody = (props) => {
  const {
    show,
    onClose,
    animate,
    modalSize,
    deliveryId,
    taskQueueId,
    cancelButtonText,
    cancelButtonStyle,
    cancelButtonVariant,
    cancelButtonClasses,
    getMarketingAttributionReportBody,
    marketingAttributionReducer: { marketingAttributionReportBody },
  } = props;

  const [deliveryBody, setDeliveryBody] = useState(emptyString);

  // Show loading while a request is running.
  const spinner = useSpinner();

  const updatedHtmlBody = (html) => {
    // Define the regular expression pattern to match the <li> element.
    const pattern = eventDateConstant.EVENT_DATE_REPLACEMENT;
    let htmlContent = html;
    if (htmlContent?.includes(pattern)) {
      // Replace the matched pattern with an empty string to remove it.
      htmlContent = htmlContent.replace(pattern, emptyString);
    }
    return htmlContent;
  };

  useEffect(() => {
    if (deliveryId) getMarketingAttributionReportBody(deliveryId, taskQueueId);
    // eslint-disable-next-line
  }, [deliveryId]);

  //Set delviery body and reset on component unmount
  useEffect(() => {
    if (marketingAttributionReportBody?.body) {
      setDeliveryBody(marketingAttributionReportBody?.body);
    }

    return () => {
      setDeliveryBody(emptyString);
    };
  }, [marketingAttributionReportBody?.body]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={animate}
      size={modalSize}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Summary</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        {spinner(
          marketingAttributionReduxConstants.GET_MARKETING_ATTRIBUTION_REPORT_BODY
        ) ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <div
            className="w-100"
            dangerouslySetInnerHTML={{
              __html: updatedHtmlBody(deliveryBody),
            }}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={cancelButtonVariant}
          className={cancelButtonClasses}
          style={cancelButtonStyle}
          onClick={onClose}
        >
          {cancelButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
const mapStateToProps = (state) => ({
  marketingAttributionReducer: state.marketingAttributionReducer,
});
const mapDispatchToProps = (dispatch) => ({
  getMarketingAttributionReportBody: (deliveryId, taskQueueId) =>
    dispatch(
      marketingAttributionActions.getMarketingAttributionReportBody(
        deliveryId,
        taskQueueId
      )
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingAttributionReportBody);
